import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list(params) {
      this.$store.commit("loading", true);
      params = params === undefined ? {} : params;

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/printers/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/printers/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    nicelabel_get(id,params) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + `/locations/${id}/nicelabel/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    add(data) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + `/printers/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    update(data) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + `/printers/${data.id}/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    deletePrinter(id) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "delete",
          url: API_BASE + `/printers/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printingIdentifier(printer, date) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/printings/",
          data: {
            printer_id: printer,
            datetime: date
          }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data.printing;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    print(printingIdentifier, itemId, quantity) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/tprintings/",
          data: {
            printing_id: printingIdentifier,
            item_types: [
              {
                item_type_id: itemId,
                quantity: quantity
              }
            ]
          }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    fileUpload(fileData) {
      this.$store.commit("loading", true);
      var formData = new FormData();
      formData.append("file", fileData);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + "/fileupload/",
          data: formData
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data.filecode;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printUploadedFile(fileCode, printerid) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/printcsv/",
          data: {
            code: fileCode,
            printer_id: printerid
          }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printUploadedFileNEW(format, responsible, fileData) {
      this.$store.commit("loading", true);
      var formData = new FormData();
      formData.append("file", fileData);
      formData.append("companyformat_id", format);
      formData.append("responsible_id", responsible);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE.replace("/api", "") + `/printer/print_order/create_by_csv/`,
          data: formData
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    downloadPrinter(locationId, fromDate, toDate) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE +
            `/porderscsv/?location_id=${locationId}&date_time_from=${fromDate}&date_time_to=${toDate}`,
          responseType: "blob"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const str = fromDate.slice(0, 10);
          const fileName = `${locationId}_${str.replaceAll("-", "")}.csv`;
          link.setAttribute("download", fileName); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    company_format(data) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE.replace("/api", "") + `/printer/company_format/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data.company_format;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getPrinterCompany(params) {
      this.$store.commit("loading", true);
      params = params === undefined ? {} : params;

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/company/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getPrinterCompanyByFilter(type) {
      this.$store.commit("loading", true);
      const params = {};

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE.replace("/api", "") +
            `/printer/company/?type_company=${type}`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    getPrinterAdminCompany() {
      this.$store.commit("loading", true);
      const params = {};

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/company/admin_company/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printer_list(params) {
      this.$store.commit("loading", true);
      params = params === undefined ? {} : params;

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/printer/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    download_nicelabel(order) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "GET",
          url: API_BASE + `/porders/${order}/nicelabel/`
        })
      )
        .then(blob => {
          var binaryData = [];
          binaryData.push(blob.data);
          var url = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: "application/*"
            })
          );
          var a = document.createElement("a");
          a.href = url;
          a.download = `${order}.csv`;
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove(); // afterwards we remove the element again
        })
        .catch(err => {
          throw err;
        });
    },

    update_nicelabel_state(data) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + `/nicelabelorder/${data.id}/`,
          data: data
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },

    printer_user(user) {
      this.$store.commit("loading", true);
      const params = {};

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/user/${user}`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    print_order(params) {
      this.$store.commit("loading", true);
      params = params === undefined ? {} : params;

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/print_order/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    set_print_order(payload) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE.replace("/api", "") + `/printer/print_order/`,
          data: payload
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printer_print(payload) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE.replace("/api", "") + `/printer/print/`,
          data: payload
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printer_progress(order_id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE.replace("/api", "") +
            `/printer/print_order/${order_id}/printer_progress/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    print_details(id, params = {}) {
      this.$store.commit("loading", true);

      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE.replace("/api", "") + `/printer/print_order/${id}/items/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printer_tagtype(params = {}) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/company_format/`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printerTagFormat() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE.replace("/api", "") + `/printer/tagformat/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    printer_cancel(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE.replace("/api", "") + `/printer/print_order/${id}/`,
          data: { canceled: "True" }
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          console.log("response.data: ", response.data);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
